import React, { createContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

export const DrawerContext = createContext();

export const DrawerProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const toggleDrawer = () => {
    setIsOpen((prevOpen) => !prevOpen);
  };
  const value = useMemo(() => ({ isOpen, toggleDrawer }), [isOpen, setIsOpen]);
  return (
    <DrawerContext.Provider value={value}>
      {children}
    </DrawerContext.Provider>
  );
};

DrawerProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
